import { PayloadAction } from '@reduxjs/toolkit';
import { Analytic, UaInfo, UserInfoInfo } from './slice';

const updateScreen = (state: Analytic) => {
    state.innerWidth = window.innerWidth;
    state.innerHeight = window.innerHeight;
    state.deviceRatio = window.devicePixelRatio;
};
const updateUaInfo = (state: Analytic, action: PayloadAction<UaInfo>) => {
    const { browser, os, device } = action.payload;
    state.deviceType = device.type ?? '';
    state.browser = browser.name ?? '';
    state.browserVersion = browser.version ?? '';
    state.os = os.name ?? '';
    state.osVersion = os.version ?? '';
};
const updateUserInfo = (
    state: Analytic,
    action: PayloadAction<UserInfoInfo>
) => {
    state.currency = action.payload.currency;
    state.lobbyCode = action.payload.lobbyCode;
    state.playerID = action.payload.playerID;
};
const updateLocale = (state: Analytic, action: PayloadAction<string>) => {
    state.locale = action.payload;
};
const updateVoiceOver = (state: Analytic, action: PayloadAction<string>) => {
    state.voiceOver = action.payload;
};
type updateBetLimitPayload = {
    minBet: number;
    maxBet: number;
};
const updateBetLimit = (
    state: Analytic,
    action: PayloadAction<updateBetLimitPayload>
) => {
    state.minBet = action.payload.minBet;
    state.maxBet = action.payload.maxBet;
};
const updateApiUrl = (state: Analytic, action: PayloadAction<string>) => {
    state.apiUrl = action.payload;
};
const updateIsMultiBet = (state: Analytic, action: PayloadAction<boolean>) => {
    state.isMultiBet = action.payload;
};
const updateIsLandscape = (state: Analytic, action: PayloadAction<boolean>) => {
    state.isLandscape = action.payload;
};
export const analyticReducer = {
    updateScreen,
    updateUaInfo,
    updateUserInfo,
    updateLocale,
    updateVoiceOver,
    updateBetLimit,
    updateApiUrl,
    updateIsMultiBet,
    updateIsLandscape,
};
